export class PersonCertificationWrite {
  public id: string;
  public name: string;
  public number: string;
  /** Date-only `YYYY-MM-DD`. */
  public activeDate: string;
  /** Date-only `YYYY-MM-DD`. */
  public expirationDate: string;
  public url: string;

  constructor() {}
}
